export default "__VITE_ASSET__KknhGsZn__"